import { render } from "./remisionGuideForm.vue?vue&type=template&id=5ff0981c&scoped=true"
import script from "./remisionGuideForm.vue?vue&type=script&lang=js"
export * from "./remisionGuideForm.vue?vue&type=script&lang=js"

import "./remisionGuideForm.vue?vue&type=style&index=0&id=5ff0981c&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff0981c"]])

export default __exports__